
import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'
/**
 * 修改公司信息
 * @param {*} params 
 */
export function updateCompany (data) {
    return axiosIns({
        url: `/api/pc/company/update`,
        method: 'put',
        owner: epmcore,
        data: data,
    })
}
// 获取公司信息
export function getCompanyDetail () {
    return axiosIns({
        url: `/api/pc/company/page`,
        method: 'get',
        owner: epmcore,
    })
}
// 获取公司信息
export function getCompany () {
    return axiosIns({
        url: `/api/pc/company/getCompany`,
        method: 'get',
        owner: epmcore,
    })
}

// 系统角色权限===============
// 更新
export function updateSysRole (data) {
    return axiosIns({
        url: `/api/pc/sysRole/update`,
        method: 'put',
        owner: epmcore,
        data: data,
    })
}
// 查询列表
export function getSysRole (params) {
    return axiosIns({
        url: `/api/pc/sysRole/page`,
        method: 'get',
        owner: epmcore,
        params
    })
}

// 查询详情
export function getSysRoleDetail (id) {
    return axiosIns({
        url: `/api/pc/sysRole/getDetail/${id}`,
        method: 'get',
        owner: epmcore,
    })
}
// 添加
export function addSysRole (data) {
    return axiosIns({
        url: `/api/pc/sysRole/add`,
        owner: epmcore,
        method: 'post',
        data: data
    })
}

// 删除
export function deleteSysRoleById (id) {
    return axiosIns({
        url: `/api/pc/sysRole/${id}`,
        owner: epmcore,
        method: 'delete'
    })
}
// 查询项目权限列表
export function getlistPermission (type) {
    return axiosIns({
        url: `/api/pc/permission/listPermission/${type}`,
        owner: epmcore,
        method: 'get'
    })
}


export function formatTree (e, pid) {
    let tree = []
    e.forEach((item) => {
        if (!item.mpttVOList) {
            tree.push({
                label: item.data.name,
                key: item.id,
                rootId: item.rootId,
                companyId: item.data.companyId,
                mpttRootId: item.data.mpttRootId,
                principal: item.data.principal,
                parentId: pid,
                children: []
            })
        } else {
            tree.push({
                label: item.data.name,
                key: item.id,
                rootId: item.rootId,
                companyId: item.data.companyId,
                mpttRootId: item.data.mpttRootId,
                principal: item.data.principal,
                parentId: pid,
                children: formatTree(item.mpttVOList, item.id)
            })
        }
    })
    return tree
}

// 获取汇报邮件配置接口
export function getReportMailSetting () {
  return axiosIns({
      url: `/api/pc/reportMailSetting`,
      owner: epmcore,
      method: 'get'
  })
}
// 获取配置
export function updateReportMailSetting (data) {
  return axiosIns({
      url: `/api/pc/reportMailSetting/update`,
      owner: epmcore,
      data:data,
      method: 'put'
  })
}







// WEBPACK FOOTER //
// ./src/views/system-manage/systemAPI.js